
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workbench",
      function () {
        return require("private-next-pages/workbench/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workbench"])
      });
    }
  